/* eslint-disable camelcase */
/* eslint-disable react/prop-types */
/** @jsxImportSource theme-ui */
import { jsx } from "theme-ui";
import React from "react";
import { Heading } from "@theme-ui/components";
import { Link } from "gatsby";
import slugger from "github-slugger";
import { colors, typography } from "../../styles/theme";

const TOCSection = ({ headings }) => (
	<>
		<Heading as="h2" sx={{ ...typography.h2, mt: ['3.5rem', '3.5rem', '3.5rem', '4.5rem'], mb: '1.5rem' }}>
			Table of Contents
		</Heading>
		<ul style={styles.ul}>
			{headings
				.filter((h) => h.depth == 2)
				.map((heading, index) => (
					<li style={styles.li}>
						<Link
							key={`toc-${index}`}
							sx={styles.linkContainer}
							to={"#" + slugger.slug(heading.value)}
						>
							{index + 1}. {heading.value}
						</Link>
					</li>
				))}
		</ul>
	</>
);

const styles = {
	gridContainer: {
		gridGap: ["0.62rem", "1.62rem", "2.62rem"],
		marginTop: "1.5rem",
		marginBottom: "3rem",
	},
	linkContainer: {
		textDecoration: "none",
		...typography.textMd400,
		color: colors.primaryMain,
	},
	ul: {
		listStyleType: 'none',
		paddingInlineStart: 0,
	},
	li: {
		marginBottom: "0.25rem",
	},
};

export default TOCSection;
